import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { APP_CONST } from "../../store/dataStore";

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table.min.css";

import { dateFormatter, moneyTableViewFormatter } from "../../util/formatter";
import MultipleSelect from "@/views/Components/MultipleSelect";
import { Button, Input } from "reactstrap";

const headerStyle = {
  backgroundColor: "#D15050",
  color: "white",
};

const rielStyle = {
  position: "relative",
  top: "0.15rem",
  fontSize: "1.15rem",
};

class TransactionsTable extends Component {
  state = {
    filter: "",
  };

  viewFormatter = (cell, row) => {
    var route = "/view_outgoing_transaction/";
    if (window.location.href.includes("/auditor-history"))
      route = "/view_audit_transaction/";
    if (window.location.href.includes("/history"))
      route = "/view_history_transaction/";

    const pathMap = {
      incoming: "/view_incoming_transaction/",
      outgoing: route,
      "account-detail": "/view_transaction/",
    };

    const { type } = this.props;
    const { sourceAccountId, fiTransactionId } = row;
    const pathname = `${pathMap[type]}${sourceAccountId}/${fiTransactionId}`;

    return (
      <Link
        to={{
          pathname,
          state: { data: row, previousLocation: { ...this.props.location } },
        }}>
        <div>
          <i
            className="fa fa-search"
            style={{ color: "#D15050" }}
            data-cy="view-tx"
          />
        </div>
      </Link>
    );
  };

  statusOptions = [
    { value: "SUCCESS", label: "SUCCESS" },
    { value: "FAILED", label: "FAILED" },
    { value: "PENDING", label: "PENDING" },
    { value: "REJECTED", label: "REJECTED" },
  ];

  businessStatusOptions = [
    { value: "RECEIVED_AT_ACH", label: "RECEIVED_AT_ACH" },
    { value: "REFUNDED_BY_RECEIVER", label: "REFUNDED_BY_RECEIVER" },
    { value: "FAILED_AT_ACH", label: "FAILED_AT_ACH" },
    { value: "PENDING", label: "PENDING" },
    { value: "ACKNOWLEDGED_BY_FI", label: "ACKNOWLEDGED_BY_FI" },
    { value: "RECEIVED_AT_FI", label: "RECEIVED_AT_FI" },
    { value: "RECEIVE_AT_ACH", label: "RECEIVE_AT_ACH" },
    { value: "FAILED_AT_FI", label: "FAILED_AT_FI" },
    { value: "RECEIVE_AT_RECEIVER_BANK", label: "RECEIVE_AT_RECEIVER_BANK" },
  ];

  handleInputChange = event => {
    this.setState({
      filter: event.target.value,
    });
    if (!this.props.options.onSearchChange) return;
    this.props.options.onSearchChange(event.target.value);
  };

  onSearch = () => {
    if (!this.props.options.onSearchClicked) return;
    this.props.options.onSearchClicked(this.state.filter);
  };

  onEnterSearch = event => {
    if (event.key === "Enter") {
      this.onSearch();
    }
  };

  handleNavigate = page => {
    let params = new URLSearchParams(this.props.location.search);
    params.set("page", page);
    params.set("filter", this.state.filter);
    this.props.location.search = params.toString();

    this.props.history.push({
      ...this.props.location,
      search: this.props.location.search,
    });
    if (!this.props.onNavigate) return;
    this.props.onNavigate(page);
  };

  onPrevious = () => {
    if (this.props.onPrevious) this.props.onPrevious();
    var currentPage = (this.props.options.page | 0) - 1;
    if (this.props.fetchInfo.hasPrevious) {
      this.handleNavigate(currentPage - 1);
    }
  };

  onNext = () => {
    if (this.props.onNext) this.props.onNext();
    var currentPage = (this.props.options.page | 0) - 1;
    if (this.props.fetchInfo.hasNext) {
      this.handleNavigate(currentPage + 1);
    }
  };

  createCustomToolBar = props => {
    return (
      <div style={{ width: "100%", float: "left" }}>
        <div className="col-2 p-0 pl-3" style={{ float: "left" }}>
          {props.components.btnGroup}
        </div>
        <div className="col-3 px-1" style={{ float: "left" }}>
          {this.props.businessStatusFilter && (
            <MultipleSelect
              options={this.businessStatusOptions}
              placeholder={"Business status"}
              onChange={values =>
                this.props.onBusinessStatusChange(
                  values ? values.map(x => x.value) : [],
                )
              }
            />
          )}
        </div>
        <div className="col-3 px-1" style={{ float: "left" }}>
          {this.props.statusFilter && (
            <MultipleSelect
              options={this.statusOptions}
              placeholder={"Status"}
              onChange={values =>
                this.props.onStatusChange(
                  values ? values.map(x => x.value) : [],
                )
              }
            />
          )}
        </div>
        <div className="col-4 p-0 pr-3" style={{ float: "right" }}>
          <Input
            style={{ paddingRight: 100 }}
            type="text"
            id="filter"
            placeholder="Search"
            onChange={this.handleInputChange}
            onKeyDown={this.onEnterSearch}
            value={this.state.filter}
          />
          <Button
            className="p-0"
            color="primary"
            style={{
              marginLeft: 20,
              width: 55,
              height: 25,
              position: "absolute",
              right: 25,
              top: 5,
            }}
            onClick={this.onSearch}
            data-cy="submit">
            Search
          </Button>
        </div>
      </div>
    );
  };

  currencyFormatter(transactionContent, row) {
    const command = transactionContent.commandList.find(
      c => c.commandCase === "TRANSFER_ASSET",
    );
    const amount = command && command.amount ? command.amount : 0;

    const isWindows = navigator.appVersion.indexOf("Win") !== -1;
    return row.currencyName === "KHR" ? (
      <>
        <span style={isWindows ? rielStyle : {}}>{APP_CONST.RIEL_SYMBOL}</span>
        {moneyTableViewFormatter(amount, row)}
      </>
    ) : (
      moneyTableViewFormatter(amount, row)
    );
  }

  defaultOptions = {
    toolBar: this.createCustomToolBar,
  };

  render() {
    return (
      <div>
        <BootstrapTable
          className="transactions-table"
          data={this.props.data}
          options={{ ...this.defaultOptions, ...this.props.options }}
          fetchInfo={this.props.fetchInfo}
          headerStyle={headerStyle}
          version="4"
          search={this.props.type === "account-detail" ? false : true}
          pagination={true}
          striped
          hover
          condensed
          remote
          exportCSV={!this.props.isAuditor}>
          <TableHeaderColumn
            dataFormat={this.viewFormatter}
            dataField="view"
            width="60"
            dataAlign="center">
            View
          </TableHeaderColumn>
          <TableHeaderColumn
            dataSort
            dataField="transactionHash"
            width="200"
            isKey>
            Trx Hash
          </TableHeaderColumn>
          {this.props.type !== "account-detail" && (
            <TableHeaderColumn dataSort dataField="extRef" width="160">
              External reference
            </TableHeaderColumn>
          )}
          <TableHeaderColumn
            dataSort
            dataFormat={dateFormatter}
            dataField="transactionCreatedTime"
            width="160">
            Entry Date
          </TableHeaderColumn>
          <TableHeaderColumn dataSort dataField="sourceAccountId" width="150">
            From Account
          </TableHeaderColumn>
          <TableHeaderColumn
            dataSort
            dataField="destinationAccountId"
            width="150">
            To Account
          </TableHeaderColumn>
          <TableHeaderColumn
            dataSort
            dataField="currencyName"
            width="70"
            dataAlign="center">
            CCY
          </TableHeaderColumn>
          <TableHeaderColumn
            dataSort
            dataField="transactionContent"
            dataFormat={this.currencyFormatter}
            width="100"
            dataAlign="right">
            Amount
          </TableHeaderColumn>
          {this.props.type !== "account-detail" && (
            <TableHeaderColumn
              dataSort
              dataField="status"
              width="150"
              dataAlign="right">
              Status
            </TableHeaderColumn>
          )}
          {this.props.type !== "account-detail" && (
            <TableHeaderColumn
              dataSort
              dataField="fstTrxStatus"
              width="150"
              dataAlign="right">
              Business Status
            </TableHeaderColumn>
          )}
          {this.props.type === "account-detail" && (
            <TableHeaderColumn
              dataSort
              dataField="transactionType"
              width="150"
              dataAlign="left">
              Transaction Type
            </TableHeaderColumn>
          )}
        </BootstrapTable>
        <div style={{ marginTop: -35, textAlign: "right" }}>
          <Button
            style={{ width: 100 }}
            onClick={this.onPrevious}
            disabled={this.props.fetchInfo.hasPrevious === false}
            data-cy="back">
            <i className="fa fa-chevron-left" style={{ marginRight: 5 }} /> Prev
          </Button>
          <Button
            color="primary"
            style={{ marginLeft: 20, width: 100 }}
            onClick={this.onNext}
            disabled={this.props.fetchInfo.hasNext === false}
            data-cy="submit">
            Next <i className="fa fa-chevron-right" style={{ marginLeft: 5 }} />
          </Button>
        </div>
      </div>
    );
  }
}

TransactionsTable.defaultProps = {
  search: true,
  onBusinessStatusChange: () => {},
  onStatusChange: () => {},
  statusFilter: false,
  businessStatusFilter: false,
};

TransactionsTable.propTypes = {
  hasNext: PropTypes.bool,
  data: PropTypes.array,
  options: PropTypes.object,
  fetchInfo: PropTypes.object,
  search: PropTypes.bool,
  location: PropTypes.object.isRequired,
  isAuditor: PropTypes.bool,
  type: PropTypes.oneOf(["incoming", "outgoing", "account-detail"]).isRequired,
  onBusinessStatusChange: PropTypes.func,
  onStatusChange: PropTypes.func,
  statusFilter: PropTypes.bool,
  businessStatusFilter: PropTypes.bool,
  onNavigate: PropTypes.func,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
};

export default withRouter(TransactionsTable);
